import { Component, h } from 'preact';

class TcrFooter extends Component
{
    render()
    {
        let items = ((this.props.config || {}).items || []).map(i => {
            return i.link ? <a href={i.link} target={i.target}>{i.title}</a> : <span>{i.title}</span>;
        });
        return (
            <div class="footer">
                {items}
            </div>
        );
    }
}

export { TcrFooter };